/**
 * Created by Nisarg on 12/19/2017.
 */
import React, {Component} from 'react';
import $ from 'jquery';

const CLIENTID = '473861865114-reblkdvrsa2b9etplbfe2hmfvdmkp3ue.apps.googleusercontent.com';
const APIKEY = 'AIzaSyBCNIlfobAJwMId0FaUjCjU4TuZAbJzhm0';
const SCOPES = 'https://www.googleapis.com/auth/gmail.readonly';

export default class Message extends Component {
    constructor(props) {
        super(props);

        this.state = {allThreads: [], mailSubject: ""}
    }

    componentDidMount() {
        this.initGoogleAuth();
    }

    initGoogleAuth() {
        const _this = this;
        const threadId = this.props.messageInfo.threadId;

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);


            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        gapi.client.load('gmail', 'v1', getThreads);
                        // _this.setState({isAuthorized: true});
                    }
                    else {
                        // _this.setState({isAuthorized: false});
                    }
                });
            }

            function getThreads() {
                let requestThread = gapi.client.gmail.users.threads.get({
                    'userId': 'me',
                    'id': threadId
                });

                requestThread.execute((response) => {
                    debugger;
                    if (response.messages != null && response.messages.length > 0) {
                        const allThreads = response.messages;
                        let mailSubject = allThreads[0].payload.headers.find((obj) => {
                            return obj.name == "Subject"
                        }).value;
                        if (mailSubject != undefined) {
                            _this.setState({mailSubject});
                        }
                        44
                        _this.setState({allThreads: response.messages});
                    }
                })
            }
        })
    }

    sendReply() {
        const _this = this;
        const threadId = this.props.messageInfo.threadId;
        const {allThreads, mailSubject} = this.state;

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);

            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        gapi.client.load('gmail', 'v1', sendReply);
                        // _this.setState({isAuthorized: true});
                    }
                    else {
                        // _this.setState({isAuthorized: false});
                    }
                });
            }

            function sendReply() {
                let requestThread = gapi.client.gmail.users.messages.sendReply({
                    'userId': 'me',
                    'threadId': threadId
                });

                if (allThreads.length > 0) {
                    const originalMessage = allThreads[0];
                    const from = originalMessage.payload.headers.find((obj) => {
                        return obj.name == "Reply-To"
                    }).value;
                    const to = originalMessage.payload.headers.find((obj) => {
                        return obj.name == "To"
                    }).value;
                    let ACCESSTOKEN = gapi.auth.getToken();
                    if (ACCESSTOKEN != undefined && Object.keys(ACCESSTOKEN).length > 0) {
                        ACCESSTOKEN = ACCESSTOKEN.access_token;
                    }

                    if ((from && to && ACCESSTOKEN) != (undefined || null)) {
                        var encodedResponse = btoa(
                            "Content-Type: text/plain; charset=\"UTF-8\"\n" +
                            "MIME-Version: 1.0\n" +
                            "Content-Transfer-Encoding: 7bit\n" +
                            "Subject: '" + mailSubject + "'\n" +
                            "From: '" + from + "'\n" +
                            "To: '" + to + "'\n\n" +

                            "Static reply is here"
                        ).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

                        fetch("https://www.googleapis.com/gmail/v1/users/me/messages/send?access_token='" + ACCESSTOKEN + "'", {
                                method: "POST",
                                contentType: "application/json",
                                data: JSON.stringify({
                                    row: encodedResponse,
                                    threadId
                                })
                            }
                        ).then((response) => {
                            debugger;
                        })
                    }
                }
            }
        })
    }

    renderThreads(thread, index) {
        const from = thread.payload.headers.find((obj) => {
            return obj.name == "From"
        }).value;
        const to = thread.payload.headers.find((obj) => {
            return obj.name == "To"
        }).value;
        let _date = thread.payload.headers.find((obj) => {
            return obj.name == "Date"
        }).value;
        let msgBody = thread.snippet;
        msgBody = msgBody.indexOf(`&lt;${to}&gt;`) >= 0 ? msgBody.substr(0, msgBody.indexOf(`&lt;${to}&gt`)) : msgBody;

        return (
            <div key={thread.id}>
                <div className="email-details clearfix">
                    <img src="img/13.jpg" alt="Philip Horbacheuski"/>
                    <div className="email-details-content">
                        <div className="pull-left">
                            <strong>{from}</strong>
                            <span className="receiver"> to <strong>{to}</strong></span>
                        </div>

                        {(index + 1 == this.state.allThreads.length) ? <div className="email-actions pull-right">
                            <div className="btn-group">
                                <button id="email-opened-reply"
                                        className="btn btn-sm btn-transparent">
                                    <i className="fa fa-reply"></i> Reply
                                </button>
                                <button
                                    className="btn btn-sm btn-transparent dropdown-toggle"
                                    data-toggle="dropdown">
                                    <i className="fa fa-angle-down"></i>
                                </button>
                                <ul className="dropdown-menu pull-right">
                                    <li><a onClick={this.sendReply.bind(this)}><i
                                        className="fa fa-reply reply-btn"></i> Reply</a>
                                    </li>
                                    <li><a href="#"><i
                                        className="fa fa-arrow-right reply-btn"></i>
                                        Forward</a></li>
                                    <li><a href="#"><i className="fa fa-print"></i>
                                        Print</a></li>
                                    <li className="divider"></li>
                                    <li><a href="#"><i className="fa fa-ban"></i>
                                        Spam</a></li>
                                    <li><a href="#"><i className="fa fa-trash"></i>
                                        Delete</a></li>
                                </ul>
                            </div>
                        </div> : ""}

                        <div className="email-date pull-right">
                            {new Date(_date).toLocaleString()}
                        </div>
                    </div>
                </div>
                <div className="email-body">
                    <p>{msgBody}</p>
                </div>
                <hr/>
            </div>
        )
    }

    render() {
        const {allThreads} = this.state;

        return (
            <div id="email-view" className="email-view">
                                                <span className="pull-right"><a href="#" className="print"><i
                                                    className="fa fa-print fa-lg"></i></a></span>
                <h4>{this.state.mailSubject}</h4>
                {allThreads.length > 0 ? allThreads.map((thread, index) => {
                    return this.renderThreads(thread, index)
                }) : ""}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/TestPage/Message.js